import { PLAN_CONFIG, type CompanySubscription, type SubscriptionPlan, type SubscriptionState } from '../types'
import { PlanTypeEnum } from '../types/enums'

const isTruthyEnv = (value?: string) => {
  const normalized = String(value || '').trim().toLowerCase()
  return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on'
}

export const isCustomerSubscriptionBypassEnabled = isTruthyEnv(
  import.meta.env.VITE_DISABLE_SUBSCRIPTION_RESTRICTIONS
)

export const shouldShowSubscriptionUi = !isCustomerSubscriptionBypassEnabled
export const shouldEnableSubscriptionAdminControls = !isCustomerSubscriptionBypassEnabled
export const CUSTOMER_UNLOCKED_PLAN_TYPE = PlanTypeEnum.GOLD

export const CUSTOMER_UNLOCKED_SUBSCRIPTION_STATE: SubscriptionState = {
  isActive: true,
  isTrialing: false,
  isExpired: false,
  isGracePeriod: false,
  daysRemaining: 36500,
  canEdit: true,
  showExpiryWarning: false,
  subscription: null
}

export const getEffectivePlanType = (subscription?: CompanySubscription | null) => {
  if (isCustomerSubscriptionBypassEnabled) {
    return CUSTOMER_UNLOCKED_PLAN_TYPE
  }

  return (subscription?.planType || PlanTypeEnum.SILVER) as PlanTypeEnum
}

export const getEffectivePlanConfig = (subscription?: CompanySubscription | null): SubscriptionPlan => {
  return PLAN_CONFIG[getEffectivePlanType(subscription)]
}
